<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <div>
        <Breadcrumbs
          headline="Chương trình đào tạo"
          :link="[{ text: 'Chương trình đào tạo', href: '../education-programs' }]"
        />
      </div>
      <div class="flex-center">
        <v-btn
          v-if="$auth.policies['add-new-division']"
          @click="createStateDialog = !createStateDialog"
          dark
          elevation="0"
          color="#0D47A1"
          class="text-uppercase"
        >
          <v-icon left>add</v-icon>THÊM CHƯƠNG TRÌNH ĐÀO TẠO
        </v-btn>
      </div>
    </div>
    <!-- <v-card v-if="$auth.role.type !== 'teacher'" outlined class="pa-6 mx-4 mb-6 elevation-0">
      <FilterPrograms @onFilterChanged="refresh" />
    </v-card> -->
    <v-card outlined class="mx-4 elevation-0">
      <EducationTable :divisions="divisions" />
    </v-card>
    <NewEducationProgramsDialog :state="createStateDialog" />
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import Breadcrumbs from '@/components/layout/Breadcrumbs'
// import DivisionDataTable from '@/modules/division/DivisionDataTable.vue'
import EducationTable from '@/modules/education-programs/EducationTable.vue'
import NewEducationProgramsDialog from '../../modules/education-programs/NewEducationProgramsDialog.vue'
import FilterPrograms from '@/modules/education-programs/Filter-programs.vue'

export default {
  components: {
    Breadcrumbs,
    // DivisionDataTable,
    EducationTable,
    NewEducationProgramsDialog,
    FilterPrograms,
  },
  props: {
    role: String,
  },
  data() {
    return {
      headers: [
        {
          text: 'Bộ môn',
          value: 'academicLevel',
          align: 'center',
          sortable: false,
          show: true,
        },
        {
          text: 'Chương trình đào tạo',
          value: 'title',
          align: 'left',
          sortable: false,
          show: true,
          width: 300,
        },
        {
          text: 'Thao tác',
          value: 'actions',
          align: 'center',
          sortable: false,
          show: true,
          width: 100,
        },
      ],
      createStateDialog: false,
      selected: {},
    }
  },

  computed: {
    ...mapState('division', ['divisions']),
    addButtonText() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
        case 'sm':
          return 'Thêm'
        default:
          return 'Thêm ban'
      }
    },
  },
  async created() {
    await this.refresh({})
  },
  methods: {
    ...mapActions({
      fetchDivision: 'division/fetchDivision',
      fetchAcademics: 'AcademicLevel/fetchAcademics',
      fetchDivisionsWithAcademicLevel: 'division/fetchDivisionsWithAcademicLevel',
    }),
    updateDraw(draw) {
      this.draw = draw
    },
    async refresh() {
      await this.fetchAcademics({})
      await this.fetchDivisionsWithAcademicLevel()
    },
    onDivisionSelected(division) {
      this.setDivision(division)
    },
  },
  filters: {
    getSubject(division) {
      return division.subjects
        .map((value) => {
          return value.title
        })
        .join(' - ')
    },
  },
}
</script>

<style scoped>
.shortenContent {
  white-space: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;
  width: 200px;
}
</style>
